const mapStateToProps = state => 
     ({
        dataOP: state.dataOP.dataOP
    });

export default mapStateToProps;
